import * as React from "react";
import Card from "@mui/material/Card";
// import CardHeader from "@mui/material/CardHeader";
// import Avatar from "@mui/material/Avatar";
import VideoIframe from "../../containers/iframe/VideoIframe";
import "./videoOverlay.css";

const VideoCardPreview = ({ videourl }) => (
  <div className="overlay" style={{ paddingLeft: "10px", paddingBottom: "10px" }}>
    <Card>
      <VideoIframe videourl={videourl} heigh="100" wid="100" />
    </Card>
  </div>
);

export default VideoCardPreview;
